import ControlPanelModal from "./control-panel-modal";

export default ControlPanelModal;